module.exports = __webpack_public_path__ + "img/logo_black_no_text.20a3d820.png";